import { Link } from 'react-router-dom';
import React from 'react';

const ErrorHandleView = () => {
  return (
    <div className="authincation">
      <div className="container">
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-7">
            <div className="form-input-content text-center error-page">
              <h1 className="error-text fw-bold">Error</h1>
              <h4>
                <i className="fa fa-thumbs-down text-danger" /> Something went
                wrong
              </h4>
              <p>
                Something went wrong with this page, so it can't display, we'll
                fix it as soon as possible
              </p>
              <div>
                <Link className="btn btn-primary" to="/">
                  Back to Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorHandleView;
